/**
 * @fileoverview gRPC-Web generated client stub for overview
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.20.3
// source: api/dashboard/v2/overview_service.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.overview = require('./overview_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.overview.OverviewClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.overview.OverviewPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.overview.NewOverviewRequest,
 *   !proto.overview.NewOverviewDataResponse>}
 */
const methodDescriptor_Overview_GetNewOverviewData = new grpc.web.MethodDescriptor(
  '/overview.Overview/GetNewOverviewData',
  grpc.web.MethodType.UNARY,
  proto.overview.NewOverviewRequest,
  proto.overview.NewOverviewDataResponse,
  /**
   * @param {!proto.overview.NewOverviewRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.overview.NewOverviewDataResponse.deserializeBinary
);


/**
 * @param {!proto.overview.NewOverviewRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.overview.NewOverviewDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.overview.NewOverviewDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.overview.OverviewClient.prototype.getNewOverviewData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/overview.Overview/GetNewOverviewData',
      request,
      metadata || {},
      methodDescriptor_Overview_GetNewOverviewData,
      callback);
};


/**
 * @param {!proto.overview.NewOverviewRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.overview.NewOverviewDataResponse>}
 *     Promise that resolves to the response
 */
proto.overview.OverviewPromiseClient.prototype.getNewOverviewData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/overview.Overview/GetNewOverviewData',
      request,
      metadata || {},
      methodDescriptor_Overview_GetNewOverviewData);
};


module.exports = proto.overview;

